<template>
  <ValidationObserver @submit="formHandler">
    <UiModalContainer
      footer-classes="flex justify-end gap-3"
      :modal-show="modal"
      :modal-width="50"
      @handleClick="handleClick"
    >
      <template v-slot:header>
        <span>Add Participants</span>
      </template>
      <template v-slot>
        <InputFieldWrapper>
          <UiSingleSelect
            v-model="participantRole"
            title="PARTICIPANT_ROLE"
            rules="required"
            label="title"
            :options="participantsRoleList"
            class="flex-1"
          />
          <UiSingleSelect
            v-model="participantsData.user_id"
            title="PARTICIPANT"
            label="full_name"
            class="flex-1"
            :options="participantsList"
            :image="true"
            reduce="id"
            rules="required"
          />
        </InputFieldWrapper>
      </template>
      <template v-slot:footer>
        <div class="flex gap-3 rtl:gap-x-4">
          <UIButton @click="handleClick('close')">Cancel</UIButton>
          <UIButton button="primary" :disabled="isLoading">
            <span v-if="isLoading">
              <Loader />
            </span>
            <span v-else>Add</span>
          </UIButton>
        </div>
      </template>
    </UiModalContainer>
  </ValidationObserver>
</template>

<script>
import UiModalContainer from '@components/UiElements/UiModalContainer.vue'
import { mapActions } from 'vuex'
import Loader from '@components/BaseComponent/Loader.vue'
import UiSingleSelect from '@/src/components/UiElements/UiSingleSelect.vue'
import UIButton from '@src/components/UiElements/UIButton.vue'
import { buildWhereQuery } from '@/src/utils/filters'
import FILTER_KEYS from '@src/constants/filter-constants.js'
import { Form as ValidationObserver } from 'vee-validate'
import InputFieldWrapper from '@/src/components/UiElements/InputFieldWrapper.vue'
import { fullName } from '@src/utils/settings/tenant-user.util.js'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'

export default {
  components: {
    UiModalContainer,
    ValidationObserver,
    Loader,
    UiSingleSelect,
    UIButton,
    InputFieldWrapper,
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    modalAction: {
      type: String,
      default: '',
    },
    studentId: {
      type: String,
      default: '',
    },
  },
  emits: ['toggle'],
  data() {
    return {
      participantsData: {
        user_id: '',
      },
      participantsList: [],
      isLoading: false,
      participantRole: '',

      participantsRoleList: [
        TENANT_ROLES.GUARDIAN,
        TENANT_ROLES.SECTION_TEACHER,
        TENANT_ROLES.STAFF,
      ],
    }
  },

  watch: {
    participantRole: {
      handler(participant) {
        if (participant) {
          this.loadParticipantUser(participant)
        }
      },
    },
  },
  methods: {
    loadParticipantUser(participant) {
      if (participant === TENANT_ROLES.SECTION_TEACHER) {
        this.getTeacherList()
      } else if (participant === TENANT_ROLES.GUARDIAN) {
        this.getStudentAssociatedGuardians()
      } else if (participant === TENANT_ROLES.STAFF) {
        this.getStaffList()
      }
    },

    getTeacherList(query = '') {
      const payload = { $where: { ...buildWhereQuery(FILTER_KEYS.ILIKE, 'search', query) } }
      payload.$where = {
        ...payload.$where,
        ...buildWhereQuery(FILTER_KEYS.EQUAL, 'campus_id', this.campus?.id),
      }
      this.getTeacherWithFilters(payload).then((response) => {
        this.participantsList = response?.data?.records
      })
    },

    getStudentAssociatedGuardians() {
      let payload = {
        $where: {
          ...buildWhereQuery(FILTER_KEYS.EQUAL, 'id', this.studentId),
        },
      }
      this.getStudentsWithFilters(payload).then((res) => {
        let responseGuardianList = res?.records[0]?.student_info?.guardians
        responseGuardianList.forEach((record) => {
          fullName(record)
          record.id = record.user_id
        })
        this.participantsList = responseGuardianList
      })
    },

    getStaffList() {
      this.getStaffWithFilters().then((res) => {
        this.participantsList = res?.data?.records
      })
    },

    formHandler() {
      if (this.modalAction === 'add participants') {
        this.addParticipant()
      } else this.addWatcher()
    },

    addParticipant() {
      this.isLoading = true
      let payload = { user_id: this.participantsData?.user_id }
      payload.role = this.participantRole
      payload.support_query_id = this.$route?.params?.id
      this.addParticipantInConversation(payload)
        .then(([res, error]) => {
          const errorMessage = error?.message
          if (!errorMessage) {
            this.$emit('toggle', true)
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    addWatcher() {
      this.isLoading = true
      let payload = { user_id: this.participantsData?.user_id }
      payload.support_query_id = this.$route?.params?.id

      this.addWatcherInConversation(payload)
        .then(([res, error]) => {
          const errorMessage = error?.message
          if (!errorMessage) {
            this.$emit('toggle', true)
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    handleClick(eventName) {
      switch (eventName) {
        case 'close':
          this.$emit('toggle')
          break
      }
    },
    ...mapActions('supportQuery', ['addParticipantInConversation', 'addWatcherInConversation']),
    ...mapActions('teacher', [, 'getTeacherWithFilters']),
    ...mapActions('student', ['getStudentsWithFilters']),
    ...mapActions('staff', ['getStaffWithFilters']),
  },
}
</script>
